import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getWellness = createAsyncThunk("WELLNESS_API", async () => {
  let config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    },
  };
  let raw = JSON.stringify({});
  try {
    const response = await axios.post(
      `${API_BASE_URL}/wellness-events/search`,
      raw,
      config
    );
    let status = "success";
    let data = {
      status: status,
      message: response,
    };
    return data;
  } catch (error) {
    let status = "error";
    let data = {
      status: status,
      message:
        error.response?.data || "Something went wrong, please try again.",
    };
    return data;
  }
});

const WellnessSlice = createSlice({
  name: "WELLNESS_SLICE",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWellness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWellness.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getWellness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default WellnessSlice.reducer;
